// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.papers-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.papers-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: clamp(460px, 38vw, 620px);
  max-width: 94vw;
  max-height: 84vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px 22px 16px;
}
.papers-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .papers-panel {
    animation: none;
  }
}

.papers-header {
  flex: 0 0 auto;
  display: block;
  padding-bottom: 14px;
}
.papers-header-icon {
  display: none;
}
.papers-header-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}

.papers-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding: 0 4px 4px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.papers-body::-webkit-scrollbar {
  width: 6px;
}
.papers-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.papers-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.papers-heading {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.papers-heading--danger {
  color: #d9786d;
}

.papers-empty {
  padding: 4px 0;
  font-size: 14px;
  color: #8d8a82;
}

.papers-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.papers-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  border-left: 3px solid var(--gold-main);
  padding: 10px 14px;
}
.papers-card-label {
  font-size: 15px;
  font-weight: 600;
  color: #ebe8e1;
}
.papers-card-holder {
  margin-top: 2px;
  font-size: 14px;
  color: #aeaba2;
}
.papers-card-date {
  margin-top: 2px;
  font-size: 13px;
  color: #8d8a82;
}
.papers-card--empire {
  border-left-color: #b45050;
}
.papers-card--thalmor {
  border-left-color: #8d8a82;
}

.papers-form-row {
  display: flex;
  gap: 8px;
}

.papers-select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
}
.papers-select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.papers-select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.papers-select option {
  background: #171b24;
  color: #ebe8e1;
}

.papers-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.papers-close-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.papers-hint-kbd {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.papers-hint-kbd kbd {
  padding: 2px 8px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.papers-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.papers-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.papers-button:active:not(:disabled) {
  transform: translateY(1px);
}
.papers-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.papers-button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.papers-button:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.papers-button--ghost {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.papers-button--ghost:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.papers-button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.papers-button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/papers/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAFA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDcU;ACVZ;;AADA;EDcE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECxJA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAUF;ADJE;EAAI,sBAAA;ACON;ADsIE;EC7JF;ID6J4C,eAAA;EClI1C;AACF;;AAfA;EACE,cAAA;EACA,cAAA;EACA,oBAAA;AAkBF;AAfE;EAAS,aAAA;AAkBX;AAhBE;EDgBA,kDA3BW;EA4BX,gBAAA;EACA,eClB6B;EDmB7B,iBAAA;EACA,sBAAA;EACA,cAxCK;AC2CP;;AArBA;ED0HE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC1HA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA0BF;AD6FE;EAAuB,UAAA;AC1FzB;AD2FE;EAA6B,oCAAA;EAAsC,kBAAA;ACvFrE;;AA9BA;EAAkB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAoCzD;;AAlCA;EDCE,kDA3BW;EA4BX,gBAAA;EACA,eCFmB;EDGnB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC6EP;AAxCE;EAAY,cDlCL;AC6ET;;AAxCA;EACE,cAAA;EACA,eAAA;EACA,cDzCO;ACoFT;;AAxCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA2CF;;AAxCA;EDvBE,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECiDP,uCAAA;EACA,kBAAA;AA6CF;AA3CE;EACE,eAAA;EACA,gBAAA;EACA,cD5DG;ACyGP;AA1CE;EACE,eAAA;EACA,eAAA;EACA,cDjEK;AC6GT;AAzCE;EACE,eAAA;EACA,eAAA;EACA,cDtEK;ACiHT;AAxCE;EAAY,0BA5FE;AAuIhB;AA1CE;EAAa,0BA5FE;AAyIjB;;AA1CA;EACE,aAAA;EACA,QAAA;AA6CF;;AA1CA;EDgCE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECtCA,cAAA;EACA,WAAA;EACA,YAAA;AAqDF;ADfE;EAAU,aAAA;EAAe,8BAAA;ACmB3B;ADlBE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACyB1G;AA9DE;EAAS,mBAAA;EAAqB,cD1FzB;AC4JP;;AA/DA;ED3CE,eAAA;EACA,gBAAA;EACA,cAlDO;ACgKT;;AAnEA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AAsEF;;AAnEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cD7GO;ACmLT;AApEE;EACE,gBAAA;EACA,yDD1GQ;EC2GR,eAAA;EACA,cDpHK;ECqHL,qCD1HS;EC2HT,0CAAA;EACA,kBAAA;AAsEJ;;AAjEA;ED9DE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC2HF;ADpIE;EAAyB,qCAAA;EAAuC,8BAAA;ACwIlE;ADvIE;EAA0B,0BAAA;AC0I5B;ADzIE;EAAa,YAAA;EAAc,mBAAA;AC6I7B;AD5IE;EAAkB,oCAAA;EAAsC,mBAAA;ACgJ1D;ADxIE;EAAyB,6BAAA;EAA+B,+BAAA;AC4I1D;AAtGE;EACE,cDlIG;ECmIH,qCAAA;EACA,sCDrIU;AC6Od;AAtGI;EAAyB,cDtItB;ECsIwC,qCAAA;EAAuC,8BAAA;AA2GtF;AAxGE;ED1CA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACqJF;ADnJE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACuPT","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Passport accents - three templates (citizenship / empire / thalmor), shown\n// as the card edge colour only.\n$empire-accent: #b45050;\n$thalmor-accent: #8d8a82;\n\n.papers-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.papers-panel {\n  @include ink.panel;\n  @include ink.enter;\n  pointer-events: auto;\n  width: clamp(460px, 38vw, 620px);\n  max-width: 94vw;\n  max-height: 84vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 22px 16px;\n}\n\n.papers-header {\n  flex: 0 0 auto;\n  display: block;\n  padding-bottom: 14px;\n\n  // Decorative glyph, no longer displayed.\n  &-icon { display: none; }\n\n  &-title { @include ink.title(26px); }\n}\n\n.papers-body {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0 4px 4px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.papers-section { display: flex; flex-direction: column; gap: 8px; }\n\n.papers-heading {\n  @include ink.title(17px);\n\n  &--danger { color: ink.$danger; }\n}\n\n.papers-empty {\n  padding: 4px 0;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n.papers-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.papers-card {\n  @include ink.block;\n  border-left: 3px solid var(--gold-main);\n  padding: 10px 14px;\n\n  &-label {\n    font-size: 15px;\n    font-weight: 600;\n    color: ink.$text;\n  }\n\n  &-holder {\n    margin-top: 2px;\n    font-size: 14px;\n    color: ink.$text-2;\n  }\n\n  &-date {\n    margin-top: 2px;\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n\n  &--empire { border-left-color: $empire-accent; }\n  &--thalmor { border-left-color: $thalmor-accent; }\n}\n\n.papers-form-row {\n  display: flex;\n  gap: 8px;\n}\n\n.papers-select {\n  @include ink.field;\n  flex: 1 1 auto;\n  width: auto;\n  min-width: 0;\n\n  option { background: #171b24; color: ink.$text; }\n}\n\n.papers-hint { @include ink.hint; }\n\n.papers-close-row {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 14px;\n  border-top: 1px solid ink.$line;\n}\n\n.papers-hint-kbd {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: ink.$text-3;\n\n  kbd {\n    padding: 2px 8px;\n    font-family: ink.$font-text;\n    font-size: 13px;\n    color: ink.$text-2;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line-strong;\n    border-radius: 4px;\n  }\n}\n\n// Primary by default (Demander); modifiers for the other kinds.\n.papers-button {\n  @include ink.button;\n  @include ink.button-primary;\n\n  &--ghost {\n    color: ink.$text;\n    background: rgba(255, 255, 255, 0.07);\n    border-color: ink.$line-strong;\n\n    &:hover:not(:disabled) { color: ink.$text; background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  }\n\n  &--danger {\n    @include ink.button-danger;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
